export enum TypeFieldEnum {
  TEXT = 'TEXT',
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  FREETEXT = 'FREETEXT',
}